var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManOfficeWorkerMediumLightSkinToneSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.75,
    height: 49.299,
    viewBox: "0 0 42.75 49.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -2.279,
    x2: 0.5,
    y2: -3.282,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#e3f2fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#d6ecfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#b4dbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90caf9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -3.442,
    x2: 0.5,
    y2: -2.606,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadada"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.716,
    r: 0.634,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#bfa055",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfa055"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "man-office-worker-medium-light-skin-tone-svgrepo-com",
    transform: "translate(-12 -4.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M33.433,96h-.058C22.832,96.012,12,98.919,12,106.272v1.213H54.751v-1.213C54.751,99.338,44.022,96,33.433,96Z",
    transform: "translate(0 -54.165)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M61.9,107.31l.974-1.911-1.911-2.249L59.056,105.4l.974,1.911L58.85,111.7h4.234Z",
    transform: "translate(-27.592 -58.375)",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M58.159,91.38H49.1L46.39,94.307l3.9,6.039,3.342-4.127,3.342,4.127,3.9-6.039Z",
    transform: "translate(-20.254 -51.444)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M58.652,84.33H54.92v4.1a3.378,3.378,0,0,0,3.4,3.358h.678a3.378,3.378,0,0,0,3.4-3.358v-4.1Z",
    transform: "translate(-25.277 -47.292)",
    fill: "#c48e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M52.831,50.43H30.362a4.7,4.7,0,0,0,0,9.38H52.827a4.7,4.7,0,0,0,0-9.38Z",
    transform: "translate(-8.222 -27.327)",
    fill: "#c48e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M44.259,11.07c-7.152,0-13.779,7.65-13.779,18.662,0,10.951,6.828,16.364,13.779,16.364s13.779-5.418,13.779-16.369c0-11.008-6.626-18.658-13.779-18.658Z",
    transform: "translate(-10.884 -4.146)",
    fill: "#e0bb95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(18.188 4.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M42.241,4.03h-.016c-18.675.1-14.848,21.433-14.848,21.433s.839,2.2,1.221,3.169a.154.154,0,0,0,.292-.021c.4-1.784,1.833-8.11,2.557-10.034A2.5,2.5,0,0,1,34.237,17a45.65,45.65,0,0,0,7.962.744h.066A45.651,45.651,0,0,0,50.228,17a2.5,2.5,0,0,1,2.791,1.574c.719,1.916,2.146,8.2,2.549,10.013a.153.153,0,0,0,.292.021l1.225-3.153c.008,0,3.835-21.33-14.843-21.429Z",
    transform: "translate(-27.053 -4.03)",
    fill: "#ab872f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M57.092,25.463S60.919,4.129,42.24,4.03h-.016c-.292,0-.575.008-.855.021-.555.025-1.093.066-1.611.127h-.016c-.037,0-.07.012-.107.016C23.915,6.172,27.376,25.463,27.376,25.463L28.6,28.62a.15.15,0,0,0,.288-.021c.4-1.8,1.833-8.1,2.557-10.018a2.5,2.5,0,0,1,2.791-1.574,45.65,45.65,0,0,0,7.962.744h.066a45.65,45.65,0,0,0,7.962-.744,2.5,2.5,0,0,1,2.791,1.574c.723,1.924,2.158,8.262,2.553,10.038a.15.15,0,0,0,.288.021C56.25,27.67,57.092,25.463,57.092,25.463Z",
    transform: "translate(-27.053 -4.03)",
    fill: "url(#radial-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManOfficeWorkerMediumLightSkinToneSvgrepoCom);
export default __webpack_public_path__ + "static/media/man-office-worker-medium-light-skin-tone-svgrepo-com.2804bc0cc5762c47d02e091cef74dd32.svg";
export { ForwardRef as ReactComponent };